import {CREATE, GET_LICENCES_CLUB, GET_ALL_LICENCE, GET_BY_ID, LICENCES_DISPATCH, UPDATE_LICENCE, GET_LICENCES_WAITING, GET_LICENCES_SOLO} from '../actions/licence'

const initialState = {
    licence: {}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE:
            return state
        case GET_ALL_LICENCE:
            return action.payload
        case GET_LICENCES_CLUB:
            return action.payload
        case LICENCES_DISPATCH:
            return action.payload
        case GET_BY_ID:
            return action.payload
        case UPDATE_LICENCE:
            return action.payload
        case GET_LICENCES_WAITING:
            return action.payload
        case GET_LICENCES_SOLO:
            return action.payload
        default:
            return state
    }
}
